/**
 * A list of names cut to the one line it is given: names are dealt in until the next would run
 * past the room, and whatever is left folds into "& more". The room is a character count
 * standing in for a measurement — the two places this is used both draw at a known type size
 * in a known width, and measuring text to lay out one line is more machinery than the answer
 * is worth.
 *
 * A workout's poster bills its exercises this way, and so does a template's row in Explore.
 * They are the same line saying the same thing — what this was made of — so they are cut by
 * the same hand rather than by two that drift apart.
 */
export function billedCast(names: readonly string[], budget: number): string {
  const SEP = ' · '
  const MORE = ' & more'
  const [first, ...rest] = names
  if (first === undefined) {
    return ' '
  }
  let line = first
  for (const [at, name] of rest.entries()) {
    const grown = line + SEP + name
    // Room is kept for "& more" unless this is the last name, where nothing would follow it.
    const reserve = at < rest.length - 1 ? MORE : ''
    if ((grown + reserve).length > budget) {
      return line + MORE
    }
    line = grown
  }
  return line
}
